import React, { useEffect, useState } from 'react';
import Footer from '../Footer';
import CartSection from './CartSection';
import Header from './Header';
import Navigation from './Navigation';
import SearchNav from './SearchNav';
import './GuestUserShoppingCart.scss';

const GuestUserShoppingCart = () => {
    const [guestUserUrlLink, setGuestUserUrlLink] = useState<any>({});
    const GetGuestUserUrlLink = () => {
        fetch("/auth/GetGuestUserUrlLink")
            .then((response) => response.json())
            .then((json) => {
                setGuestUserUrlLink(json);
            })
            .catch((error) => {
                setGuestUserUrlLink({});
            });
    };

    useEffect(() => {
        GetGuestUserUrlLink();
    }, [])

    return (
        <div>
            <div className='GuestUser_Wrapper'>
                <Header guestUserUrlLink={guestUserUrlLink} />
                <div className='clearfix'>
                  {/* <Navigation/> */}
                    <Navigation guestUserUrlLink={guestUserUrlLink} />
                </div>
                <div className='clearfix searchnav_wrapper'>
                    <SearchNav guestUserUrlLink={guestUserUrlLink} />
                </div>
                <div className='clearfix'>
                  <CartSection />
                </div>
                <div className='clearfix'>
                  <Footer/>
                </div>
            </div>
        </div>
    );
};

export default GuestUserShoppingCart;